import React, { useEffect, useState } from 'react';
import Overlay from './components/laroca/Overlay';
import GameReward from './pages/GameReward';
import Passport from './pages/Passport';
import InstructionsVillageInfo from './pages/VillageInfo';
import AcPDP from './pages/laroca/AcPDP';
import AtYourService from './pages/laroca/AtYourService';
import Instructions from './pages/laroca/Instructions';
import Sculpture from './pages/laroca/Sculpture';
import ShoppingExpress from './pages/laroca/ShoppingExpress';
import SignupPDP from './pages/laroca/SignupPDP';
import AppartmentServices from './pages/laroca/apartments/Services';
import ShopFromHome from './pages/laroca/apartments/ShopFromHome';
import PersonalStylist from './pages/laroca/apartments/Stylist';
import ApartmentWelcome from './pages/laroca/apartments/Welcome';
import Andreu from './pages/laroca/restaurants/Andreu';
import Farggi from './pages/laroca/restaurants/Farggi';
import FlaxKale from './pages/laroca/restaurants/FlaxKale';
import Illuzione from './pages/laroca/restaurants/Illuzione';
import Mordisco from './pages/laroca/restaurants/Mordisco';
import Pasarela from './pages/laroca/restaurants/Pasarela';
import { disptchCTAClickObject } from './Analytics';
const villageName = 'la_roca';

function LaRocaApp() {
  const [activeScene, setActiveScene] = useState('room-1');
  const [instructionsActive, setInstructionsActive] = useState(false);
  const [villageInfoActive, setVillageInfoActive] = useState(false);
  const [passportActive, setPassportActive] = useState(false);
  const [atYourServiceActive, setAtYourServiceActive] = useState(false);
  const [shoppingExpActive, setShoppingExpActive] = useState(false);
  const [acPDPActive, setAcPDPActive] = useState(false);
  const [signupPDPActive, setSignupPDPActive] = useState(false);
  const [illuzioneActive, setIlluzioneActive] = useState(false);
  const [andreuActive, setAndreuActive] = useState(false);
  const [flaxActive, setFlaxActive] = useState(false);
  const [farggiActive, setFarggiActive] = useState(false);
  const [mordiscoActive, setMordiscoActive] = useState(false);
  const [pasarelaActive, setPasarelaActive] = useState(false);
  const [stylistActive, setStylistActive] = useState(false);
  const [sfhActive, setSfhActive] = useState(false);
  const [appartmentServicesActive, setAppartmentServiceActive] = useState(false);
  const [apartmentWelcomeActive, setApartmentWelcomeActive] = useState(false);
  const [sculptureActive, setSculptureActive] = useState(false);
  const [gameRewardActive, setGameRewardActive] = useState(false);

  const openAtYourService = () => {
    disptchCTAClickObject('laroca', 'Button', 'AtYourService', 'Open', '');
    setAtYourServiceActive(true);
  };

  const closeAtYourService = () => {
    disptchCTAClickObject('laroca', 'Button', 'AtYourService', 'Close', '');
    setAtYourServiceActive(false);
  };

  const openShoppingExpress = () => {
    disptchCTAClickObject('laroca', 'Button', 'ShoppingExpress', 'Open', '');
    setShoppingExpActive(true);
  };

  const closeShoppingExpress = () => {
    disptchCTAClickObject('laroca', 'Button', 'ShoppingExpress', 'Close', '');
    setShoppingExpActive(false);
  };

  const openAcPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'ArtAndCulture', 'Open', '');
    setAcPDPActive(true);
  };

  const closeAcPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'ArtAndCulture', 'Close', '');
    setAcPDPActive(false);
  };

  const openSignupPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Signup', 'Open', '');
    setSignupPDPActive(true);
  };

  const closeSignupPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Signup', 'Close', '');
    setSignupPDPActive(false);
  };

  const openIlluzionePDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Illuzione', 'Open', '');
    setIlluzioneActive(true);
  };

  const closeIlluzionePDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Illuzione', 'Close', '');
    setIlluzioneActive(false);
  };

  const openAndreuPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Andreu', 'Open', '');
    setAndreuActive(true);
  };

  const closeAndreuPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Andreu', 'Close', '');
    setAndreuActive(false);
  };

  const openFlaxPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Flax', 'Open', '');
    setFlaxActive(true);
  };

  const closeFlaxPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Flax', 'Close', '');
    setFlaxActive(false);
  };

  const openFarggiPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Farggi', 'Open', '');
    setFarggiActive(true);
  };

  const closeFarggiPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Farggi', 'Close', '');
    setFarggiActive(false);
  };

  const openMordiscoPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Mordisco', 'Open', '');
    setMordiscoActive(true);
  };

  const closeMordiscoPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Mordisco', 'Close', '');
    setMordiscoActive(false);
  };

  const openPasarelaPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Pasarela', 'Open', '');
    setPasarelaActive(true);
  };

  const closePasarelaPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Pasarela', 'Close', '');
    setPasarelaActive(false);
  };

  const openStylistPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Stylist', 'Open', '');
    setStylistActive(true);
  };

  const closeStylistPDP = () => {
    disptchCTAClickObject('laroca', 'Button', 'Stylist', 'Close', '');
    setStylistActive(false);
  };

  const openShopFromHome = () => {
    disptchCTAClickObject('laroca', 'Button', 'ShopFromHome', 'Open', '');
    setSfhActive(true);
  };

  const closeShopFromHome = () => {
    disptchCTAClickObject('laroca', 'Button', 'ShopFromHome', 'Close', '');
    setSfhActive(false);
  };

  const openAppartmentServices = () => {
    disptchCTAClickObject('laroca', 'Button', 'Apartment', 'Open', '');
    setAppartmentServiceActive(true);
  };

  const closeApartmentServices = () => {
    disptchCTAClickObject('laroca', 'Button', 'Apartment', 'Close', '');
    setAppartmentServiceActive(false);
  };

  // const openWomenswear = () => {
  //   setWomenswearActive(true);
  // };

  // const openMenswear = () => {
  //   setMenswearActive(true);
  // };

  // const openSportswear = () => {
  //   setSportswearActive(true);
  // };

  // const openBagsLuggage = () => {
  //   setBagsLuggageActive(true);
  // };

  // const openShoes = () => {
  //   setShoesActive(true);
  // };

  // const openAccessories = () => {
  //   setAccessoriesActive(true);
  // };

  // const openHomeware = () => {
  //   setHomewareActive(true);
  // };

  // const openBeauty = () => {
  //   setBeautyActive(true);
  // };

  const openVillageInfo = () => {
    setVillageInfoActive(true);
  };

  const closeInstructions = () => {
    toggleInstructionsAction(false);
    setVillageInfoActive(true);
  };

  const openPassport = () => {
    setPassportActive(true);
  };

  const openApartmentWelcome = () => {
    disptchCTAClickObject('laroca', 'Button', 'ApartmentWelcome', 'Open', '');
    setApartmentWelcomeActive(true);
  };

  const closeApartmentWelcome = () => {
    disptchCTAClickObject('laroca', 'Button', 'ApartmentWelcome', 'Close', '');
    setApartmentWelcomeActive(false);
  };

  const openSculpture = () => {
    disptchCTAClickObject('laroca', 'Button', 'Sculpture', 'Open', '');
    setSculptureActive(true);
  };

  const closeSculpture = () => {
    disptchCTAClickObject('laroca', 'Button', 'Sculpture', 'Close', '');
    setSculptureActive(false);
  };

  const updateActiveScene = (sceneName: string) => {
    // setActiveScene(sceneName);
    // window.changeUrls();
    if (activeScene !== sceneName) {
      setActiveScene(sceneName);
      window.changeUrls();
    }
  };

  const openGameReward = () => {
    disptchCTAClickObject('laroca', 'Button', 'GameReward', 'Open', '');
    setGameRewardActive(true);
  };

  const closeGameReward = () => {
    disptchCTAClickObject('laroca', 'Button', 'GameReward', 'Close', '');
    setGameRewardActive(false);
  };

  const toggleInstructionsAction = (isActive: boolean) => {
    const cta_action: string = isActive ? 'Open' : 'Close';
    setInstructionsActive(isActive);
    disptchCTAClickObject('laroca', 'Button', 'Instructions', cta_action, '');
  };

  const togglePassportAction = (isActive: boolean) => {
    const cta_action: string = isActive ? 'Open' : 'Close';
    setPassportActive(isActive);
    disptchCTAClickObject('laroca', 'Button', 'Passport', cta_action, '');
  };

  const closeVillageInfo = () => {
    setVillageInfoActive(false);
    disptchCTAClickObject('laroca', 'Button', 'VillageInfo', 'close', '');
  };

  useEffect(() => {
    window.openAtYourService = openAtYourService;
    window.openShoppingExpress = openShoppingExpress;
    window.openAcPDP = openAcPDP;
    window.openSignupPDP = openSignupPDP;
    window.openIlluzionePDP = openIlluzionePDP;
    window.openAndreuPDP = openAndreuPDP;
    window.openFlaxPDP = openFlaxPDP;
    window.openFarggiPDP = openFarggiPDP;
    window.openMordiscoPDP = openMordiscoPDP;
    window.openPasarelaPDP = openPasarelaPDP;
    window.openStylistPDP = openStylistPDP;
    window.openShopFromHome = openShopFromHome;
    window.openAppartmentServices = openAppartmentServices;
    window.openVillageInfo = openVillageInfo;
    window.openPassport = openPassport;
    window.openApartmentWelcome = openApartmentWelcome;
    window.updateActiveScene = updateActiveScene;
    window.openSculpture = openSculpture;
    window.openGameReward = openGameReward;
  }, []);

  return (
    <>
      {/* <LoadingScreen setLoadUI={() => setLoadUI(true)} /> */}
      {/* {loadUI && ( */}
      <>
        <Overlay
          closeAllUI={() => {
            setInstructionsActive(false);
          }}
          openFirstModal={() => setInstructionsActive(true)}
          activeScene={activeScene}
          setActiveScene={setActiveScene}
          togglePassport={() => {
            togglePassportAction(!passportActive);
          }}
          toggleInstructions={() => {
            toggleInstructionsAction(!instructionsActive);
          }}
          // toggleMap={() => {
          //   setMapActive(!mapActive);
          // }}
        />
        <Instructions active={instructionsActive} setActive={closeInstructions} />
        <InstructionsVillageInfo
          active={villageInfoActive}
          setActive={() => closeVillageInfo()}
          villageName={villageName}
        />
        <Passport active={passportActive} setActive={() => togglePassportAction(false)} villageName={villageName} />
        <AtYourService active={atYourServiceActive} setActive={() => closeAtYourService()} />
        <ShoppingExpress active={shoppingExpActive} setActive={() => closeShoppingExpress()} />
        <AcPDP active={acPDPActive} setActive={() => closeAcPDP()} />
        <SignupPDP active={signupPDPActive} setActive={() => closeSignupPDP()} />
        <Illuzione active={illuzioneActive} setActive={() => closeIlluzionePDP()} />
        <Andreu active={andreuActive} setActive={() => closeAndreuPDP()} />
        <FlaxKale active={flaxActive} setActive={() => closeFlaxPDP()} />
        <Farggi active={farggiActive} setActive={() => closeFarggiPDP()} />
        <Mordisco active={mordiscoActive} setActive={() => closeMordiscoPDP()} />
        <Pasarela active={pasarelaActive} setActive={() => closePasarelaPDP()} />
        <PersonalStylist active={stylistActive} setActive={() => closeStylistPDP()} />
        <ShopFromHome active={sfhActive} setActive={() => closeShopFromHome()} />
        <AppartmentServices active={appartmentServicesActive} setActive={() => closeApartmentServices()} />
        <ApartmentWelcome active={apartmentWelcomeActive} setActive={() => closeApartmentWelcome()} />
        <Sculpture active={sculptureActive} setActive={() => closeSculpture()} />
        <GameReward villageName="laroca" active={gameRewardActive} setActive={() => closeGameReward()} />
      </>
    </>
  );
}

export default LaRocaApp;
